import { getFieldContainerStyles, getHiddenStyles, getFieldInputStyles, getFieldIconStyles } from './EditableTextFieldStyles.js';
import { Typography } from '../../../components/Typography/Typography.js';
import { IconNames } from '@shipengine/giger-theme';
import { useKeyPress } from '../../../utils/hooks/useKeyPress.js';
import { forwardRef, useState, useRef } from 'react';
import { useMergeRefs } from 'use-callback-ref';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import useMeasure from '../../../hooks/useMeasure/useMeasure.js';
import { Icon } from '../../../components/Icon/Icon.js';
import { IconSize } from '../../../components/Icon/types/size.js';

const EditableTextField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    name,
    inputRef,
    value = '',
    placeholder,
    onBlur,
    onFocus,
    variant = 'heading2',
    editAriaLabel = 'Edit',
    ...rest
  } = props;
  const [isFocused, setIsFocused] = useState(false);
  const newRef = useRef(null);
  const mergedRef = useMergeRefs(inputRef ? [newRef, inputRef] : [newRef]);
  const [hiddenValueRef, {
    width
  }] = useMeasure();
  const onBlurInput = event => {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    setIsFocused(false);
  };
  const onFocusInput = event => {
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    setIsFocused(true);
  };
  const {
    handleKeyPress
  } = useKeyPress({
    onEnter: () => {
      var _mergedRef$current;
      return (_mergedRef$current = mergedRef.current) === null || _mergedRef$current === void 0 ? void 0 : _mergedRef$current.focus();
    }
  });
  const onClick = () => {
    var _mergedRef$current2;
    return (_mergedRef$current2 = mergedRef.current) === null || _mergedRef$current2 === void 0 ? void 0 : _mergedRef$current2.focus();
  };
  return jsxs("div", {
    className: className,
    ref: ref,
    css: getFieldContainerStyles(isFocused),
    children: [jsx(Typography, {
      css: getHiddenStyles,
      variant: variant,
      ref: hiddenValueRef,
      children: value || placeholder
    }), jsx("input", {
      name: name,
      id: name,
      ref: mergedRef,
      value: value,
      placeholder: placeholder,
      onBlur: onBlurInput,
      onFocus: onFocusInput,
      css: getFieldInputStyles(variant, width),
      ...rest
    }), jsx("div", {
      role: "button",
      tabIndex: 0,
      css: getFieldIconStyles(isFocused),
      onClick: onClick,
      onKeyUp: handleKeyPress,
      "aria-label": editAriaLabel,
      children: jsx(Icon, {
        name: IconNames.EDIT,
        size: IconSize.SIZE_SMALL
      })
    })]
  });
});
EditableTextField.displayName = 'EditableTextField';

export { EditableTextField };
//# sourceMappingURL=EditableTextField.js.map
